import ImageDeepTagging from './ImageDeepTagging'

export default ImageDeepTagging
